import React from 'react';
import SectionHeadingStyle2 from '../../SectionHeading/SectionHeadingStyle2';
import TradeFair from '../../Service/TradeFair';

export default function ServiceSectionStyle4({
  data,
  sectionTitleUp,
  sectionTitle,
}) {
  return (
    <div className="container">
      <SectionHeadingStyle2
        sectionTitleUp={sectionTitleUp}
        sectionTitle={sectionTitle}
      />
      <div className="row">
        {data?.map((item, index) => (
          <div className="col-xl-4 col-md-6" key={index}>
            <TradeFair {...item} />
          </div>
        ))}
      </div>
    </div>
  );
}
